module.exports = __webpack_public_path__ + "2b9b6b498712bda132dda2231a37741f.svg";